import React, { useContext, useState, useEffect } from "react";
import { Link as DomLink, useLocation } from "react-router-dom";
import { storage } from "../../utils";
import { DiamondSearchContext } from "../../utils/stateHandlers/contexts";
import _ from "lodash";
import ShapeFilter from "./controls/filters/ShapeFilter";
import parse from "html-react-parser";
import Modal from "./controls/Modal";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import HelpIcon from "@mui/icons-material/Help";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkboxes, Range, RangeNominal } from "./controls/filters";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CameraAlt from "@mui/icons-material/CameraAlt";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Default, Mobile } from "../../utils/deviceHelpers";
import LocalShippingTwoToneIcon from "@mui/icons-material/LocalShippingTwoTone";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 34,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "& + .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "#939598",
    },
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#7fa04d",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    boxSizing: "border-box",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function CertDiamondFilters(props) {
  const { diamondState, dispatch } = useContext(DiamondSearchContext);
  const {
    filters,
    advancedFilters,
    showAdvancedFilters,
    searchQuery,
    tableHeaders,
    resetFilters,
    openHelpText,
    helpTextLabel,
    showFancyColorFilter,
    helpText,
  } = diamondState;
  const [showHelp, setShowHelp] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  //const [showFancyColorFilter, setShowFancyColorFilter] = useState(false);
  const [sameDayToggle, setSameDayToggle] = useState(false);
  const [imageToggle, setImageToggle] = useState(false);
  const [localFcIntensity, setLocalFcIntensity] = useState("None");
  const loggedIn = storage.getStorageItem("authToken");
  const sendTo = useLocation();
  const valuesForColor = _.find(searchQuery.fields, function (field) {
    return field.name === "MinedOrLab";
  });
  const valueForColor = valuesForColor && valuesForColor.values[0].name;

  function updateFilters(filterName, filterValues) {
    const filterToUpdate = _.find(searchQuery.fields, function (field) {
      return field.name === filterName;
    });
    const rangeOrValues =
      filterName === "HooverPrice" ||
      filterName === "Carat" ||
      filterName === "LWRatio" ||
      filterName === "Table" ||
      filterName === "Depth"
        ? "range"
        : "values";
    if (filterName === "MinedOrLab") {
      clearFilters();
    }
    if (filterToUpdate) {
      if (rangeOrValues === "range") {
        filterToUpdate.range = filterValues;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      } else {
        filterToUpdate.values = filterValues;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      }
    } else {
      if (rangeOrValues === "range") {
        const fields = _.concat(searchQuery.fields, {
          name: filterName,
          range: filterValues,
        });
        dispatch({ type: "updateSearchQuery", payload: fields });
      } else {
        const fields = _.concat(searchQuery.fields, {
          name: filterName,
          values: filterValues,
        });
        dispatch({ type: "updateSearchQuery", payload: fields });
      }
    }
  }

  function clearFilters(minedOrLab) {
    dispatch({
      type: "clearFilters",
      payload: [minedOrLab],
    });
  }

  function updateCheckedBoxes(filterName, values) {
    if (
      filterName === "AsGrown" ||
      filterName === "ScsGrower" ||
      filterName === "ShipsSameDay" ||
      filterName === "ImageVideoAvailable"
    ) {
      if (values.checked === "N") {
        const newSearchQuery = _.filter(
          searchQuery.fields,
          function (queryField) {
            return queryField.name !== filterName;
          }
        );
        dispatch({ type: "updateSearchQuery", payload: newSearchQuery });
      } else {
        updateFilters(filterName, [{ name: values.checked }]);
      }
    } else {
      const searchValues = [];
      _.map(values, function (value) {
        if (value.checked === true) {
          searchValues.push({ name: value.name });
        }
        return;
      });
      updateFilters(filterName, searchValues);
    }
  }

  function updateRange(filterName, range) {
    updateFilters(filterName, range);
  }

  function updateNominalRange(filterName, marks, sliderValue) {
    const newArray = marks
      .filter(
        (m) => m.value + 0.1 > sliderValue[0] && m.value + 0.1 < sliderValue[1]
      )
      .map((m) => {
        return { name: m.label };
      });
    updateFilters(filterName, newArray);
  }

  function isFcActive(colorName) {
    const selectedValue = _.find(searchQuery.fields, function (field) {
      return field.name === "FancyColor";
    });
    if (selectedValue) {
      const bool = _.find(selectedValue.values, function (value) {
        return value.name === colorName ? true : false;
      });
      return bool;
    }
  }

  function selectionFilter(filterName, valueName) {
    if (filterName === "FancyColorIntensity") {
      setLocalFcIntensity(valueName);
    }
    const searchField = _.find(searchQuery.fields, function (field) {
      return field.name === filterName;
    });
    if (searchField) {
      const valueFound = _.find(searchField.values, function (value) {
        return value.name === valueName;
      });
      if (filterName === "FancyColorIntensity" && valueName === "None") {
        const removeSelected = _.remove(searchQuery.fields, function (field) {
          return field.name !== filterName;
        });
        searchQuery.fields = removeSelected;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      } else if (valueFound) {
        const removeSelected = _.remove(searchField.values, function (value) {
          return value.name !== valueName;
        });
        searchField.values = removeSelected;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      } else {
        const newSelectedValues = _.concat(searchField.values, {
          name: valueName,
        });
        searchField.values = newSelectedValues;
        dispatch({ type: "updateSearchQuery", payload: searchQuery.fields });
      }
    } else {
      const newSearchFields = _.concat(searchQuery.fields, {
        name: filterName,
        values: [
          {
            name: valueName,
          },
        ],
      });
      dispatch({ type: "updateSearchQuery", payload: newSearchFields });
    }
  }

  function switchToFancyColors(switchValue) {
    //need to call update filters when switch is clicked to display fnacy color diamonds in results
    dispatch({
      type: "setShowFancyColorFilter",
      payload: showFancyColorFilter === true ? false : true,
    });
    if (!showFancyColorFilter) {
      updateFilters("Color", [{ name: "" }]);
    } else {
      const removeColorFilter = _.remove(searchQuery.fields, function (field) {
        return field.name !== "Color";
      });
      dispatch({ type: "updateSearchQuery", payload: removeColorFilter });
    }
  }

  const FancyColor = () => (
    <Stack spacing={1}>
      <Stack direction="row">
        <Button
          onClick={() => selectionFilter("FancyColor", "Yellow")}
          disableElevation
          variant="contained"
          color="diamondYellow"
          sx={
            isFcActive("Yellow")
              ? {
                  width: "25%",
                  height: "2.5rem",
                  border: "2px solid black",
                  color: "black",
                }
              : { width: "25%", height: "2.5rem" }
          }
        >
          Yellow
        </Button>
        <Button
          onClick={() => selectionFilter("FancyColor", "Pink")}
          disableElevation
          variant="contained"
          color="pink"
          sx={
            isFcActive("Pink")
              ? {
                  width: "25%",
                  height: "2.5rem",
                  border: "2px solid black",
                  color: "black",
                }
              : { width: "25%", height: "2.5rem" }
          }
        >
          Pink
        </Button>
        <Button
          onClick={() => selectionFilter("FancyColor", "Blue")}
          disableElevation
          variant="contained"
          color="diamondBlue"
          sx={
            isFcActive("Blue")
              ? {
                  width: "25%",
                  height: "2.5rem",
                  border: "2px solid black",
                  color: "black",
                }
              : { width: "25%", height: "2.5rem" }
          }
        >
          Blue
        </Button>
        <Button
          onClick={() => selectionFilter("FancyColor", "Green")}
          disableElevation
          variant="contained"
          color="diamondGreen"
          sx={
            isFcActive("Green")
              ? {
                  width: "25%",
                  height: "2.5rem",
                  border: "2px solid black",
                  color: "black",
                }
              : { width: "25%", height: "2.5rem" }
          }
        >
          Green
        </Button>
      </Stack>
      <Select
        size="small"
        sx={{ width: "35%", height: "2.5rem" }}
        MenuProps={{
          PaperProps: {
            sx: {
              border: "1px solid #939598",
              borderRadius: "0",
              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            },
          },
        }}
        value={localFcIntensity}
        onChange={(e) => selectionFilter("FancyColorIntensity", e.target.value)}
      >
        <MenuItem value="None">
          <em>Select Intensity (optional)</em>
        </MenuItem>
        <MenuItem value="Deep">Deep</MenuItem>
        <MenuItem value="Faint">Faint</MenuItem>
        <MenuItem value="Fancy">Fancy</MenuItem>
        <MenuItem value="Fancy Light">Fancy Light</MenuItem>
        <MenuItem value="Intense">Intense</MenuItem>
        <MenuItem value="Very Light">Very Light</MenuItem>
        <MenuItem value="Vivid">Vivid</MenuItem>
      </Select>
    </Stack>
  );

  const MinedOrLab = () => {
    const helpText = _.find(tableHeaders, function (header) {
      return header.name === "MinedOrLab";
    });

    return (
      <Grid container>
        <Grid item className="mined-filter" sx={{ width: "100%" }}>
          <Button
            disableElevation
            variant="contained"
            color={valueForColor === "M" ? "primary" : "secondary"}
            onClick={() => {
              clearFilters({
                name: "MinedOrLab",
                values: [{ name: "M" }],
              });
            }}
          >
            Mined
          </Button>
          <Button
            disableElevation
            variant="contained"
            color={valueForColor === "L" ? "success" : "secondary"}
            onClick={() => {
              clearFilters({
                name: "MinedOrLab",
                values: [{ name: "L" }],
              });
            }}
          >
            Lab-Grown
          </Button>
          <HelpIcon
            sx={{ marginLeft: "10px" }}
            className="help-icon question-mark"
            onClick={() => setShowHelp(true)}
          />
        </Grid>
        <Modal
          title={"Mined Or Lab-Grown"}
          onClose={() => setShowHelp(false)}
          show={showHelp}
        >
          {filters.length > 0 ? parse(helpText.help_text) : ""}
        </Modal>
      </Grid>
    );
  };

  useEffect(() => {
    setLocalFcIntensity("None");
    setSameDayToggle(false);
    setImageToggle(false);
    dispatch({
      type: "setShowFancyColorFilter",
      payload: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetFilters]);

  return (
    <>
      <Mobile>
        <Stack spacing={1} alignItems="center">
          <Typography>
            Need help finding the perfect diamond? &nbsp;
            <span
              className="contact-us pointer"
              onClick={() => setShowContactModal(true)}
            >
              Contact Us
            </span>
          </Typography>
          {MinedOrLab()}
          {filters &&
            filters.map((filter) => (
              <Accordion
                key={filter.name}
                square={true}
                disableGutters={true}
                sx={{ width: "100%", minHeight: "unset", paddingRight: "1rem" }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                    }}
                  >
                    {filter.label}
                    {filter.label === "Source" ||
                    filter.label === "Features" ? (
                      <DomLink
                        to={{
                          pathname: "/sub-landing/Diamond-Sources",
                        }}
                        target="_blank"
                      >
                        <HelpIcon className="help-icon question-mark" />
                      </DomLink>
                    ) : (
                      <>
                        {filter.label !== "Price" && (
                          <HelpIcon
                            className="help-icon question-mark"
                            onClick={() =>
                              dispatch({
                                type: "setOpenHelpText",
                                payload: {
                                  open: true,
                                  label: filter.label,
                                  text: parse(filter.help_text),
                                },
                              })
                            }
                          />
                        )}
                      </>
                    )}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {filter.type === "options" && filter.label === "Shape" ? (
                    <ShapeFilter updateFilters={updateFilters} />
                  ) : filter.type === "options" && filter.label !== "Shape" ? (
                    <Checkboxes
                      search={searchQuery}
                      filter={filter}
                      resetFilters={resetFilters}
                      updateCheckedBoxes={updateCheckedBoxes}
                    />
                  ) : filter.type === "enum" ? (
                    <RangeNominal
                      filter={filter}
                      resetFilters={resetFilters}
                      updateNominalRange={updateNominalRange}
                      color={valueForColor === "M" ? "primary" : "success"}
                    />
                  ) : filter.type === "numeric" &&
                    filter.name !== "HooverPrice" ? (
                    <Range
                      filter={filter}
                      resetFilters={resetFilters}
                      updateRange={updateRange}
                      color={valueForColor === "M" ? "primary" : "success"}
                    />
                  ) : filter.name === "HooverPrice" && !loggedIn ? (
                    <DomLink
                      to={{
                        pathname: "/login",
                        state: { sendTo: sendTo.pathname },
                      }}
                    >
                      <Button variant="contained" color="error">
                        Login For pricing
                      </Button>
                    </DomLink>
                  ) : filter.name === "HooverPrice" && loggedIn ? (
                    <Range
                      filter={filter}
                      resetFilters={resetFilters}
                      updateRange={updateRange}
                      color={valueForColor === "M" ? "primary" : "success"}
                    />
                  ) : null}
                </AccordionDetails>
              </Accordion>
            ))}
          {showAdvancedFilters && (
            <>
              {advancedFilters &&
                advancedFilters.map((filter) => (
                  <Accordion
                    square={true}
                    disableGutters={true}
                    sx={{
                      width: "100%",
                      minHeight: "unset",
                      paddingRight: "1rem",
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                        sx={{
                          textTransform: "uppercase",
                        }}
                      >
                        {filter.label}
                        {filter.label === "Source" ||
                        filter.label === "Features" ? (
                          <DomLink
                            to={{
                              pathname: "/sub-landing/Diamond-Sources",
                            }}
                            target="_blank"
                          >
                            <HelpIcon className="help-icon question-mark" />
                          </DomLink>
                        ) : (
                          <>
                            {filter.label !== "Price" && (
                              <HelpIcon
                                className="help-icon question-mark"
                                onClick={() =>
                                  dispatch({
                                    type: "setOpenHelpText",
                                    payload: {
                                      open: true,
                                      label: filter.label,
                                      text: parse(filter.help_text),
                                    },
                                  })
                                }
                              />
                            )}
                          </>
                        )}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {filter.type === "options" && filter.label === "Shape" ? (
                        <ShapeFilter />
                      ) : filter.type === "options" &&
                        filter.label !== "Shape" ? (
                        <Checkboxes
                          search={searchQuery}
                          filter={filter}
                          resetFilters={resetFilters}
                          updateCheckedBoxes={updateCheckedBoxes}
                        />
                      ) : filter.type === "enum" ? (
                        <RangeNominal
                          filter={filter}
                          resetFilters={resetFilters}
                          updateNominalRange={updateNominalRange}
                          color={valueForColor === "M" ? "primary" : "success"}
                        />
                      ) : filter.type === "numeric" ? (
                        <Range
                          filter={filter}
                          resetFilters={resetFilters}
                          updateRange={updateRange}
                          color={valueForColor === "M" ? "primary" : "success"}
                        />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>
                ))}
            </>
          )}
          <Stack spacing={1} sx={{ paddingBottom: "2rem" }}>
            <FormControlLabel
              control={
                <CustomSwitch
                  id="ImageVideoAvailable"
                  type="checkbox"
                  sx={{ marginLeft: "1rem" }}
                  onChange={(e) =>
                    updateCheckedBoxes("ImageVideoAvailable", {
                      name: "ImageVideoAvailable",
                      checked: e.target.checked ? "Y" : "N",
                    })
                  }
                />
              }
              label={
                <Typography
                  variant="body3"
                  sx={{ fontWeight: "800", marginLeft: "2rem" }}
                >
                  Image/Video Available <CameraAlt color="primary" />
                </Typography>
              }
            />
            {searchQuery.fields.find((f) => f.name === "MinedOrLab").values[0]
              .name === "L" && (
              <FormControlLabel
                control={
                  <CustomSwitch
                    id="ShipsSameDay"
                    type="checkbox"
                    onClick={(e) =>
                      updateCheckedBoxes("ShipsSameDay", {
                        name: "ShipsSameDay",
                        checked: e.target.checked ? "Y" : "N",
                      })
                    }
                  />
                }
                label={
                  <Typography variant="subtitle1" sx={{ marginLeft: "2rem" }}>
                    Ships Same Day <LocalShippingTwoToneIcon color="error" />
                  </Typography>
                }
              />
            )}
          </Stack>
        </Stack>
        <Divider flexItem sx={{ marginBottom: "2rem" }}>
          {!showAdvancedFilters ? (
            <Chip
              color={valueForColor === "M" ? "primary" : "success"}
              label="Show More Filters"
              icon={<ArrowDropDownIcon />}
              onClick={() =>
                dispatch({ type: "showAdvancedFilters", payload: true })
              }
            />
          ) : (
            <Chip
              color={valueForColor === "M" ? "primary" : "success"}
              label="Show Less Filters"
              icon={<ArrowDropUpIcon />}
              onClick={() =>
                dispatch({ type: "showAdvancedFilters", payload: false })
              }
            />
          )}
        </Divider>
      </Mobile>
      <Default>
        <Stack spacing={1} alignItems="center" sx={{ marginBottom: "2rem" }}>
          {MinedOrLab()}
          <Typography>
            Need help finding the perfect diamond? &nbsp;
            <span
              className="contact-us pointer"
              onClick={() => setShowContactModal(true)}
            >
              Contact Us
            </span>
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                sm: "repeat(1, 1fr)",
                md: "repeat(2, 1fr)",
                lg: "repeat(2, 1fr)",
                xl: "repeat(2, 1fr)",
              },
              paddingTop: "2rem",
            }}
          >
            {filters &&
              filters.map((filter) => (
                <Stack
                  key={filter.name}
                  direction="row"
                  spacing={2}
                  sx={{ marginLeft: "2rem", marginBottom: "1.5rem" }}
                >
                  <Typography
                    sx={{
                      width: "12%",
                      paddingTop:
                        filter.label === "Source" ||
                        filter.label === "Features" ||
                        filter.label === "Report"
                          ? "2.8rem"
                          : ".6rem",
                      textTransform: "uppercase",
                    }}
                  >
                    <Stack>
                      {filter.name === "HooverPrice" ? (
                        "Price"
                      ) : (
                        <Stack direction="row">
                          {filter.label}
                          {filter.label === "Source" ||
                          filter.label === "Features" ? (
                            <DomLink
                              to={{
                                pathname: "/sub-landing/Diamond-Sources",
                              }}
                              target="_blank"
                            >
                              <HelpIcon className="help-icon question-mark" />
                            </DomLink>
                          ) : (
                            <>
                              {filter.name !== "HooverPrice" && (
                                <HelpIcon
                                  className="help-icon question-mark"
                                  onClick={() =>
                                    dispatch({
                                      type: "setOpenHelpText",
                                      payload: {
                                        open: true,
                                        label: filter.label,
                                        text: parse(filter.help_text),
                                      },
                                    })
                                  }
                                />
                              )}
                            </>
                          )}
                        </Stack>
                      )}
                      {/* {filter.name === "Color" && (
                        <FormControlLabel
                          sx={{
                            marginTop: "1rem",
                            paddingTop: ".5rem",
                          }}
                          control={
                            <CustomSwitch
                              id="ShowFancyColorFilter"
                              type="checkbox"
                              sx={{ marginLeft: "1rem" }}
                              checked={showFancyColorFilter}
                              onChange={(e) =>
                                switchToFancyColors(e.target.value)
                              }
                            />
                          }
                          label={
                            <Typography
                              variant="fancyFilterFont"
                              sx={{
                                paddingLeft: "1rem",
                                textTransform: "capitalize",
                              }}
                            >
                              FANCY
                            </Typography>
                          }
                        />
                      )} */}
                    </Stack>
                  </Typography>
                  <Box
                    component="span"
                    sx={{
                      paddingLeft: "3rem",
                      paddingRight: "3rem",
                      width: "93%",
                    }}
                  >
                    {filter.type === "options" && filter.label === "Shape" ? (
                      <ShapeFilter updateFilters={updateFilters} />
                    ) : filter.type === "options" &&
                      filter.label !== "Shape" ? (
                      <Checkboxes
                        search={searchQuery}
                        filter={filter}
                        resetFilters={resetFilters}
                        updateCheckedBoxes={updateCheckedBoxes}
                      />
                    ) : filter.type === "enum" &&
                      filter.name === "Color" &&
                      !showFancyColorFilter ? (
                      <RangeNominal
                        filter={filter}
                        resetFilters={resetFilters}
                        updateNominalRange={updateNominalRange}
                        color={valueForColor === "M" ? "primary" : "success"}
                      />
                    ) : // filter.type === "enum" &&
                    //   filter.name === "Color" &&
                    //   showFancyColorFilter ? (
                    //   FancyColor()
                    // ) :
                    filter.type === "enum" ? (
                      <RangeNominal
                        filter={filter}
                        resetFilters={resetFilters}
                        updateNominalRange={updateNominalRange}
                        color={valueForColor === "M" ? "primary" : "success"}
                      />
                    ) : filter.type === "numeric" &&
                      filter.name !== "HooverPrice" ? (
                      <Range
                        filter={filter}
                        resetFilters={resetFilters}
                        updateRange={updateRange}
                        color={valueForColor === "M" ? "primary" : "success"}
                      />
                    ) : filter.name === "HooverPrice" && !loggedIn ? (
                      <DomLink
                        to={{
                          pathname: "/login",
                          state: { sendTo: sendTo.pathname },
                        }}
                      >
                        <Button variant="contained" color="error">
                          Login For pricing
                        </Button>
                      </DomLink>
                    ) : filter.name === "HooverPrice" && loggedIn ? (
                      <Range
                        filter={filter}
                        resetFilters={resetFilters}
                        updateRange={updateRange}
                        color={valueForColor === "M" ? "primary" : "success"}
                      />
                    ) : null}
                  </Box>
                </Stack>
              ))}
            {showAdvancedFilters && (
              <>
                {advancedFilters &&
                  advancedFilters.map((filter) => (
                    <Stack
                      key={filter.name}
                      direction="row"
                      spacing={2}
                      sx={{ marginLeft: "2rem", marginBottom: "1.5rem" }}
                    >
                      <Typography
                        sx={{
                          width: "12%",
                          paddingTop: ".6rem",
                          textTransform: "uppercase",
                        }}
                      >
                        {filter.label}
                        {filter.label === "Source" ||
                        filter.label === "Features" ? (
                          <a
                            href={
                              process.env.REACT_APP_PHP_SITE_URL +
                              "diamond-sources"
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <HelpIcon className="help-icon question-mark" />
                          </a>
                        ) : (
                          <>
                            {filter.label !== "Price" && (
                              <HelpIcon
                                className="help-icon question-mark"
                                onClick={() =>
                                  dispatch({
                                    type: "setOpenHelpText",
                                    payload: {
                                      open: true,
                                      label: filter.label,
                                      text: parse(filter.help_text),
                                    },
                                  })
                                }
                              />
                            )}
                          </>
                        )}
                      </Typography>
                      <Box
                        component="span"
                        sx={{
                          paddingLeft: "3rem",
                          paddingRight: "3rem",
                          width: "93%",
                        }}
                      >
                        {filter.type === "options" &&
                        filter.label === "Shape" ? (
                          <ShapeFilter />
                        ) : filter.type === "options" &&
                          filter.label !== "Shape" ? (
                          <Checkboxes
                            search={searchQuery}
                            filter={filter}
                            resetFilters={resetFilters}
                            updateCheckedBoxes={updateCheckedBoxes}
                          />
                        ) : filter.type === "enum" ? (
                          <RangeNominal
                            filter={filter}
                            resetFilters={resetFilters}
                            updateNominalRange={updateNominalRange}
                            color={
                              valueForColor === "M" ? "primary" : "success"
                            }
                          />
                        ) : filter.type === "numeric" ? (
                          <Range
                            filter={filter}
                            resetFilters={resetFilters}
                            updateRange={updateRange}
                            color={
                              valueForColor === "M" ? "primary" : "success"
                            }
                          />
                        ) : null}
                      </Box>
                    </Stack>
                  ))}
              </>
            )}
            <Stack direction="row" spacing={1} sx={{ marginLeft: "15rem" }}>
              {searchQuery.fields.find((f) => f.name === "MinedOrLab").values[0]
                .name === "L" && (
                <FormControlLabel
                  control={
                    <CustomSwitch
                      id="ShipsSameDay"
                      type="checkbox"
                      checked={sameDayToggle}
                      onClick={(e) => {
                        updateCheckedBoxes("ShipsSameDay", {
                          name: "ShipsSameDay",
                          checked: e.target.checked ? "Y" : "N",
                        });
                        setSameDayToggle(e.target.value);
                      }}
                    />
                  }
                  label={
                    <Typography variant="subtitle1" sx={{ marginLeft: "2rem" }}>
                      Ships Same Day <LocalShippingTwoToneIcon color="error" />{" "}
                      NEW!!!
                    </Typography>
                  }
                />
              )}
              <FormControlLabel
                control={
                  <CustomSwitch
                    id="ImageVideoAvailable"
                    type="checkbox"
                    sx={{ marginLeft: "1rem" }}
                    checked={imageToggle}
                    onClick={(e) => {
                      updateCheckedBoxes("ImageVideoAvailable", {
                        name: "ImageVideoAvailable",
                        checked: e.target.checked ? "Y" : "N",
                      });
                      setImageToggle(e.target.value);
                    }}
                  />
                }
                label={
                  <Typography
                    variant="body3"
                    sx={{ fontWeight: "800", marginLeft: "2rem" }}
                  >
                    Image/Video Available <CameraAlt color="primary" />
                  </Typography>
                }
              />
            </Stack>
          </Box>
          <Divider flexItem>
            {!showAdvancedFilters ? (
              <Chip
                color={valueForColor === "M" ? "primary" : "success"}
                label="Show More Filters"
                icon={<ArrowDropDownIcon />}
                onClick={() =>
                  dispatch({ type: "showAdvancedFilters", payload: true })
                }
              />
            ) : (
              <Chip
                color={valueForColor === "M" ? "primary" : "success"}
                label="Show Less Filters"
                icon={<ArrowDropUpIcon />}
                onClick={() =>
                  dispatch({ type: "showAdvancedFilters", payload: false })
                }
              />
            )}
          </Divider>

          <Modal
            title={helpTextLabel}
            onClose={() =>
              dispatch({
                type: "setOpenHelpText",
                payload: {
                  open: false,
                  label: "",
                  text: "",
                },
              })
            }
            show={openHelpText}
          >
            {helpText}
          </Modal>
          <Modal
            title="Contact Us"
            onClose={() => setShowContactModal(false)}
            show={showContactModal}
          />
        </Stack>
      </Default>
    </>
  );
}
